import React from "react";
import { FileUploader } from "react-drag-drop-files";
import Heroicon from "../Heroicon";

function PreviewCover({ handleChange, podcastCover, setPodcastCover }) {
  function checkDimensions(e) {
    // Intrinsic image values
    const naturalWidth = e.target.naturalWidth;
    const naturalHeight = e.target.naturalHeight;

    // Checking valid values
    const validAspectRatio = naturalWidth / naturalHeight === 1; // True if it's a perfect square
    const validWidth = naturalWidth >= 1400 && naturalWidth <= 3000;
    const validHeight = naturalHeight >= 1400 && naturalHeight <= 3000;

    let validWidthMsg = "";
    if (naturalWidth < 1400) {
      validWidthMsg = "not wide enough";
    } else if (naturalWidth > 3000) {
      validWidthMsg = "too wide";
    }
    let validHeightMsg = "";
    if (naturalHeight < 1400) {
      validHeightMsg = "not high enough";
    } else if (naturalHeight > 3000) {
      validHeightMsg = "too high";
    }
    let join = "";
    if (validWidthMsg !== "" && validHeightMsg !== "") {
      join = "and";
    }

    setPodcastCover({
      ...podcastCover,
      dimensions: `${naturalWidth}px x ${naturalHeight}px`,
      validDimensions: validWidth && validHeight,
      validDimensionsMsg: `Image is ${validWidthMsg} ${join} ${validHeightMsg}`,
      validRatio: validAspectRatio,
      validType: e.target.tagName === "IMG" || false,
    });
  }

  function handlePicInput(file) {
    handleChange("cover_image", file);

    let reader = new FileReader();
    reader.onload = (e) => {
      setPodcastCover({
        ...podcastCover,
        src: e.target.result,
        size: `${(e.total / 1024 / 1024).toFixed(2)} MB`,
        validSize: Math.round(e.total / 1024 / 1024) <= 1,
      });
    };
    reader.readAsDataURL(file);
  }

  return (
    <FileUploader
      multiple={false}
      handleChange={handlePicInput}
      name="file"
      types={["JPEG", "JPG", "PNG"]}
      hoverTitle=" "
      classes={`block bg-gray-100 hover:bg-gray-200 overflow-hidden border-2 ${
        podcastCover.src
          ? "border-white"
          : "border-dashed border-gray-300 hover:border-gray-400"
      } rounded-xl h-0 pb-[100%] sm:pb-0 sm:h-56 sm:w-56 cursor-pointer`}
    >
      {podcastCover.src ? (
        <img
          src={podcastCover.src}
          className="absolute inset-0 block object-cover min-h-full rounded-xl"
          onLoad={checkDimensions}
          alt="Podcast Cover"
        />
      ) : (
        <div className="rounded-xl text-center border-gray-300 h-0 pb-[100%] sm:h-56 sm:w-56 relative">
          <p className="text-gray-500 absolute inset-x-0 -translate-y-1/2 top-[50%] text-sm">
            <Heroicon icon="o-arrow-up-tray" style="w-8 h-8 mx-auto mb-3" />
            Upload here
          </p>
        </div>
      )}
    </FileUploader>
  );
}

export default PreviewCover;
